import Keycloak, { KeycloakInitOptions } from 'keycloak-js';

let keycloak: Keycloak;

let initPromise: Promise<boolean>;
let logoutInProgress = false;

function initKeycloak() {
  const initOptions: KeycloakInitOptions = {
    onLoad: 'login-required',
    checkLoginIframe: false,
  };

  initPromise = keycloak
    .init(initOptions)
    .then(async (authenticated) => {
      if (!authenticated) {
        console.warn('Unauthenticated');
        await keycloak.login();
      } else {
        console.log('Authenticated');
      }
      return authenticated;
    })
    .catch((error) => {
      console.error('Authentication failed:', error);
      throw error;
    });

  return keycloak;
}

export function createKeycloakInstanceFromJson(jsonPath: string) {
  keycloak = new Keycloak(jsonPath);
  return initKeycloak();
}

export function createKeycloakInstanceFromConfig(config: Keycloak.KeycloakConfig) {
  keycloak = new Keycloak(config);
  return initKeycloak();
}

export function onKeycloakReady(): Promise<boolean> {
  return initPromise;
}

export function getToken(): string | undefined {
  return keycloak?.token;
}

export async function login() {
  await keycloak.login();
}

export async function updateToken(minValidity: number) {
  await keycloak.updateToken(minValidity);
}

export function authenticated(): boolean {
  return keycloak?.authenticated === true;
}

export async function logoutFromApp() {
  if (logoutInProgress) return;

  logoutInProgress = true;
  try {
    return await keycloak.logout();
  } catch (error) {
    logoutInProgress = false;
    throw error;
  }
}

export function getUserRoles() {
  return keycloak?.tokenParsed?.realm_access?.roles || [];
}

export function getIdToken(): string | undefined {
  return keycloak?.idToken;
}

export function getSessionExpiration(): Date | undefined {
  if (keycloak?.tokenParsed && keycloak.tokenParsed.exp) {
    return new Date(keycloak.tokenParsed.exp * 1000);
  }
  return undefined;
}

export default {
  createKeycloakInstanceFromJson,
  createKeycloakInstanceFromConfig,
  onKeycloakReady,
  getToken,
  logoutFromApp,
  login,
  updateToken,
  authenticated,
  getUserRoles,
  getIdToken,
  getSessionExpiration,
};
